/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"

import iconPrelievi from '../../../../images/icon_prelievi.svg';
import iconCrowdfunding from '../../../../images/icon_crowdfunding.svg';
import iconStore from '../../../../images/icon_store.svg';
import * as s from './css/vantaggi-pacchetto.module.css';

const VantaggiPacchetto = ({ data, className, boxes, title="Tutti i vantaggi del tuo conto Tinaba Hit" }) => {

    const _boxes = boxes ? boxes : [
        { image: iconStore, titolo: 'Store Esclusivo', testo: 'Accedi a vantaggi, prevendite e sconti sui prodotti della tua star preferita!' },
        { image: iconCrowdfunding,  titolo: 'Crowdfunding Unlimited', testo: 'Il tuo progetto di crowdfunding non ha limiti e puoi raccogliere donazioni tramite Tinaba, Carte di pagamento e Paypal' },
        { image: iconPrelievi,  titolo: 'Prelievi gratuiti', testo: 'Ricevi gratuitamente la tua carta con spedizione rapida. Se hai bisogno di contanti, preleva gratuitamente da un qualsiasi ATM in UE!' },
    ];

    return (
        <>
            <div className={`flex flex-col mx-auto ${s.container}`}>
                <div className={`mx-auto container-grid`}>
                    <div className="text-24 text-primary text-center font-md leading-16 mx-4 desktop:mx-0 desktop:leading-11 col-span-4 desktop:col-span-12">{title}</div>
                </div>
                <div className={`flex flex-col desktop:flex-row leading-loose mx-auto container-grid ${s.containerTuttiBox}`}>
                    {_boxes.map((box, indexBox) => (
                        <div key={`advantagesPlan_${indexBox}`} className={`col-span-4 flex-1 shadow-2 ${s.containerSingoloBox}`}>
                            <div className={`flex absolute rounded-full shadow-3 bg-white items-center justify-center content-center ${s.containerCircleImage}`}>
                                <img src={box.image} className="w-2/5 h-2/5" alt={box.titolo} />
                            </div>
                            <div className={`text-3 font-md text-primary text-center ${s.boxTitle}`}>{box.titolo}</div>
                            <div className={`text-8 font-rg text-black text-center leading-5 ${s.boxDescription}`}>{box.testo}</div>
                        </div>
                        ))}

                </div>
            </div>

        </>
    )
}


export default VantaggiPacchetto
